module.exports = __webpack_public_path__ + "img/icon-reg-personal-ticket.811280ac.png";